import { toggleNav } from '../../js/main'
import '../../css/reset.css'
import '../../css/constants.css'
import '../../css/main.css'
import './hydrocarbon-recovery-systems.css'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

gsap.set(document.querySelector('body'), {
    visibility: 'visible'
})
var systemsCardArray = gsap.utils.toArray('.systems-card');
systemsCardArray.forEach((card) => {
  console.log('card', card)
    gsap.from(card, { 
        y: 35,
        autoAlpha: 0,
        ease: 'sine',
        scrollTrigger: {
            trigger: card,
            start: 'top+=50 bottom',
            scrub: true,
            end: 'bottom top+=500',
            // once: true,
            // markers: true
        }
    });
})
var systemsInfoArray = gsap.utils.toArray('.systems-info');
systemsInfoArray.forEach((info) => {
    const lis = info.querySelectorAll('li');
    gsap.from(lis, { 
        x: 25,
        autoAlpha: 0,
        ease: 'sine',
        stagger: 0.1,
        scrollTrigger: {
            trigger: info,
            start: 'top bottom',
            scrub: true,
            end: 'bottom top+=500',
            // once: true,
            // toggleActions: 'play none'
            // markers: true
        }
    });
})


toggleNav()
// entry()
console.log('this is hydrocarbon recovery system page');